import { render, staticRenderFns } from "./AgendaEdit.vue?vue&type=template&id=5dd1e5c5&"
import script from "./AgendaEdit.vue?vue&type=script&lang=ts&"
export * from "./AgendaEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports